import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { throttle } from 'lodash';

class Docked extends React.Component {
    static propTypes = {
        children: PropTypes.any
    };

    constructor(props, context) {
        super(props, context);

        this._updateCallback = throttle(() => this.scroll(), 100);
        
        this.componentRef = React.createRef();
        this.containerRef = React.createRef();

        this.state = {
            offset: 0,
            height: 0
        };
    }

    componentDidMount() {
        this.scroll();

        window.addEventListener('resize', this._updateCallback);
        const container = this.containerRef.current;
        container && container.offsetParent && container.offsetParent.addEventListener('scroll', this._updateCallback);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this._updateCallback);

        const container = this.containerRef.current;
        if ( container && container.offsetParent ) {
            container.offsetParent.removeEventListener('scroll', this._updateCallback);
        }
    }

    scroll() {
        const component = this.componentRef.current;
        const container = this.containerRef.current;
        
        if (!component || !container) return;
        
        const rect = component.getBoundingClientRect();
        const parentRect = component.offsetParent.getBoundingClientRect();

        const height = parentRect.bottom - parentRect.top;

        const padding = Math.min(Math.max(0, parentRect.top - rect.top), parentRect.top - rect.top + height);

        component.style['paddingTop'] = padding + 'px';
        container.style['height'] = height + 'px';
    }

    render() {
        return (
            <div className="docked" ref={this.componentRef}>
                <div className="docked-container" ref={this.containerRef}>
                    { this.props.children }
                </div>
            </div>
        );
    }
}

export default Docked;
